enum DialogNames {
  ADD_BUSINESS_CHILD = 'ADD_BUSINESS_CHILD',
  CREATE_PRACTICE = 'CREATE_PRACTICE',
  CREATE_PRACTICE_GROUP = 'CREATE_PRACTICE_GROUP',
  DISMISSIBLE_ALERT = 'DISMISSIBLE_ALERT',
  TEAM_MEMBER = 'TEAM_MEMBER',
  UPLOAD_IMAGE = 'UPLOAD_IMAGE',
}

export default DialogNames
